var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56 0c-.437 0-.796.14-1.078.422-.28.281-.421.64-.421 1.078v.75H.56v1.5h.75v12c0 .61.218 1.14.656 1.594.453.437.984.656 1.594.656h9c.609 0 1.132-.219 1.57-.656.453-.453.68-.985.68-1.594v-12h.75v-1.5h-4.5V1.5c0-.438-.141-.797-.422-1.078C10.357.14 9.998 0 9.56 0h-3zm0 1.5h3v.75h-3V1.5zM2.81 3.75h10.5v12a.741.741 0 01-.234.54.701.701 0 01-.516.21h-9a.782.782 0 01-.539-.21.782.782 0 01-.21-.54v-12zM4.31 6v8.25h1.5V6h-1.5zm3 0v8.25h1.5V6h-1.5zm3 0v8.25h1.5V6h-1.5z",
    fill: "#D82C0D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "assets/images/delete.66344c30b2266e7ab8002de121c1a892.svg";
export { ForwardRef as ReactComponent };